'use strict';
import { BaseService } from '@narrate/base-sdk';

/**
 * stores the FCM notification token
 *
 * future work:
 *  may handle conflict resolution
 *
 * @example
 *    // using CoreService (recommended)
 *    import Core from '@narrate/core-sdk';
 *
 *
 *    await Core.api.notifications.syncToken(token);
 */
class NotificationsService extends BaseService {

  constructor() {
    super({ configPath: 'services.notifications' });
  }

  syncToken = async token => {
    return await this.requestResource('syncToken', {
      method: 'post',
      data: { token },
    });
  }
}

export default NotificationsService;
